import React from 'react';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './hiservices.css';

const HIservices = () => {
  /** Sorted A–Z; class names use hi-svc-* to avoid collision with topservices.css .service-card */
  const inspectionServices = [
    {
      title: 'Dampness Inspection',
      tagline: 'Pinpoint hidden moisture and seepage before walls and finishes suffer.',
      icon: '💧',
      slug: 'dampness-inspection'
    },
    {
      title: 'Doors & Windows Inspection',
      tagline: 'Check alignment, sealing, and smooth, safe operation across openings.',
      icon: '🚪',
      slug: 'doors-windows-inspection'
    },
    {
      title: 'Electrical Inspection',
      tagline: 'Uncover risky wiring, loose terminations, and hotspots early.',
      icon: '⚡',
      slug: 'electrical-inspection'
    },
    {
      title: 'Plumbing Inspection',
      tagline: 'Validate pipes, pressure, and fixtures so leaks do not surprise you later.',
      icon: '🔧',
      slug: 'plumbing-inspection'
    },
    {
      title: 'RERA Carpet Area Verification',
      tagline: 'Independent carpet-area measurement aligned with RERA norms.',
      icon: '📏',
      slug: 'rera-carpet-area-verification'
    },
    {
      title: 'Walls & Flooring Inspection',
      tagline: 'Assess finishes, cracks, hollow tiles, and surface quality room by room.',
      icon: '🏠',
      slug: 'walls-flooring-inspection'
    }
  ];

  return (
    <div className="hi-services-section" id="services">
      <div className="hi-services-container">
        <div className="hi-services-header">
          <div className="hi-services-badge">
            <CheckCircleIcon className="badge-icon" />
            <span>Professional services</span>
          </div>
          <h2 className="hi-services-title">Explore Key Parameters Included in Our Home Inspection Packages</h2>
          <p className="hi-services-description">
          Our home inspection covers key parameters to detect hidden defects before possession and provides a clear builder-friendly report for smooth handover.
          </p>
        </div>

        <div className="hi-services-grid">
          {inspectionServices.map((service) => (
            <article key={service.title} className="hi-svc-card">
              <div className="hi-svc-card-inner">
                <div className="hi-svc-icon-wrap" aria-hidden>
                  <span className="hi-svc-emoji">{service.icon}</span>
                </div>
                <h3 className="hi-svc-title">{service.title}</h3>
                <p className="hi-svc-tagline">{service.tagline}</p>
                <Link
                  className="hi-svc-link"
                  to={`/${encodeURIComponent(service.slug)}`}
                >
                  <span>Learn more</span>
                  <ArrowForwardIcon className="hi-svc-link-arrow" aria-hidden />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HIservices;
